import {
  type AvailabilityBlock,
  buildDisplayBlocks,
} from 'features/Home/Book/Booking/Schedule/PatientSchedule/ScheduleCalendar/scheduleAvailability'
import type { DoctorAvailabilityGroup } from 'features/Schedule/api/schedule.types'

export type DoctorAvailabilityInput = {
  availability: DoctorAvailabilityGroup[] | undefined
  // Null until the EMR providers load.
  emrLinkedUserIds: Set<number> | null
  staffId: number | undefined
}

// Same gate as the calendar; nothing while loading, so the preview never flashes fully off.
export const doctorAvailabilityBlocks = ({
  availability,
  emrLinkedUserIds,
  staffId,
}: DoctorAvailabilityInput): AvailabilityBlock[] => {
  if (!staffId || !availability || !emrLinkedUserIds?.has(staffId)) return []
  return buildDisplayBlocks(availability, [staffId])
}
